import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { user } from "../viewmodel/user";
import { insurance } from "../viewmodel/insurance";

// Define the store state type
interface UserState {
  userData: user;
  insuranceData: insurance;
  token: string;
  isAnesthesiologist: boolean;
  isMedicalCenter: boolean;
  isAdmin: boolean;
  isInsuranceAgent: boolean;
  memberLevel: string;
  reset: () => void;
}

const initialState = {
  userData: new user(),
  insuranceData: new insurance(),
  token: '',
  isAnesthesiologist: false,
  isMedicalCenter: false,
  isAdmin: false,
  isInsuranceAgent: false,
  memberLevel: '0',
};

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      ...initialState,
      reset: () => set(initialState),
    }),
    {
      name: 'gd-user-storage',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);